export default __webpack_public_path__ + "static/media/naturpool-2.db96497a.jpeg";